import { RouterLink, RouterLinkActive } from '@angular/router';
import { input, inject, computed, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { ProfilePermission } from '@/app/api/profile';
import { PermissionsService } from '@/app/core/services/permissions';

export interface NavigationMenuItem {
  label: string;
  icon?: string;
  link: string[];
  permissions?: ProfilePermission[];
}

@Component({
  selector: 'app-navigation-menu',
  imports: [RouterLinkActive, RouterLink],
  templateUrl: './navigation-menu.component.html',
  styleUrl: './navigation-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'navigation-menu',
    role: 'navigation',
  },
})
export class NavigationMenuComponent {
  private permissionsService = inject(PermissionsService);

  items = input.required<NavigationMenuItem[]>();

  readonly visibleItems = computed(() => {
    const all = this.items();
    return all.filter((item) => {
      if (!item.permissions || item.permissions.length === 0) {
        return true;
      }

      return this.permissionsService.hasPermissions(item.permissions);
    });
  });
}
